export const pixelsToRem = (pixels) => {
  const result = Number(pixels) / 16;
  return `${result}rem`;
}